export default __webpack_public_path__ + "0874840b4f5dce83709d51f4e178ab04.svg";